import React, { useEffect, useState } from "react";
import "./FilterComp.css";

import { useDispatch, useSelector } from "react-redux";
import { FilterValue } from "../../redux/actions/index";
import { Link, useLocation } from "react-router-dom";
import gamefilter from "../../dataset/gamefilter.json";
import { useTranslation } from 'react-i18next';


function FilterComp() {
  // const t = useI18n();
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation

  const dispatch = useDispatch();
  const numberOFFilterd = useSelector((state) => state.data); // array of Games => 15 array
  const location = useLocation(); // ใช้ useLocation เพื่อดึงข้อมูล URL ปัจจุบัน

  let [Filtervalue, setFiltervalue] = useState(7)
  useEffect(() => {
    dispatch(FilterValue(Filtervalue))

  }, [Filtervalue])

  const filters = gamefilter


  return (
    <div className="Filter__container text-capitalize ">
      <ul className="unstyle-list m-0 p-0">
        {filters.map((filter) => (
          <Link
            to={filter.path}
            key={filter.value}
            className={[
              "list-group-item d-flex justify-content-between align-items-center",
              location.pathname === filter.path ? "active" : "", // เช็ค URL ปัจจุบัน
            ].join(" ")}
            style={{ cursor: "pointer", padding: "10px" }}
            onClick={() => setFiltervalue(filter.value)}
          >
            <div>
              {/* <i
                className={`fa-solid ${filter.icon}`}

              /> */}

              <img
                src={require(`../../assets/icons/${filter.icon}`)}
                alt={`${filter.category}`}
                width={20}
              />
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                value={filter.value}
                onClick={(e) => setFiltervalue(e.target.value)}
                id={`flexRadioDefault${filter.value}`}
                style={{ display: "none" }}
              />
              <label
                className="form-check-label ms-2"
                htmlFor={`flexRadioDefault${filter.value}`}

              >
                {/* {filter.label} */}
                {t(filter.category)}
              </label>
            </div>
          </Link>
        ))}
      </ul>

    </div>
  );
}

export default FilterComp;
